/**
 * @desc For easier icon use
 * @example Use our standard close icon, size 14px: <i cs-icon="close" cs-icon-size="14"></i>
 */
;(function () {
  'use strict'

  angular.module('contrast.icons').directive('csIcon', ['csIconConfig', csIcon])

  function csIcon(csIconConfig) {
    return {
      restrict: 'A',
      scope: {
        csIconKey: '=?',
        csIconSize: '=?'
      },
      link: function (scope, elem, attrs) {
        var prevClass, key
        if (attrs.csIcon) {
          // csIcon takes precedence
          key = attrs.csIcon
          update()
        } else {
          // watch for csIconKey
          scope.$watch(
            function () {
              return scope.csIconKey
            },
            function (newVal) {
              if (angular.isString(newVal)) {
                key = scope.csIconKey
                update()
              }
            }
          )
        }

        function update() {
          if (key && csIconConfig[key]) {
            var val = csIconConfig[key]
            if (prevClass) {
              elem.removeClass(prevClass)
            }
            elem.addClass(val)
            prevClass = val
          }
          if (scope.csIconSize) {
            elem.css({ 'font-size': scope.csIconSize + 'px' })
          }
        }
      }
    }
  }
})()
